const deleteSpecialCharacters = (str) => {
    return str.replace(/[\[\].,()']+/g, "")
}

export default deleteSpecialCharacters